import { css } from 'styled-components';
import { lighten, darken, rgba } from 'polished';
import { ButtonStyleProps } from 'types/buttons';

export const buttonStyle = css<ButtonStyleProps>`
  background-color: ${props => props.theme.colors.siteGrey};
  border-color: ${props => props.theme.colors.siteGrey};
  color: ${props => props.theme.colors.black};

  border-width: 1px;
  border-style: solid;
  transition: all 0.3s ease-in-out;
  padding: 13px 10px;
  cursor: pointer;
  height: 40px;
  position: relative;
  border-radius: 3px;
  font-size: 1.2rem;
  font-family: ${props => props.theme.fonts.montserratMedium};
  text-align: center;
  // line-height: 1.2rem;
  display: inline-block;

  ${props => {
    if (props.blue) {
      return css`
        background-color: ${props.theme.colors.siteBlue};
        border-color: ${props.theme.colors.siteBlue};
        color: ${props.theme.colors.white};
      `;
    } else if (props.white) {
      return css`
        background-color: ${props.theme.colors.white};
        border-color: ${props.theme.colors.white};
        color: ${props.theme.colors.black};
      `;
    } else if (props.darkNavy) {
      return css`
        background-color: ${props.theme.colors.siteDarkNavy};
        border-color: ${props.theme.colors.siteDarkNavy};
        color: ${props.theme.colors.white};
      `;
    } else if (props.black) {
      return css`
        background-color: ${props.theme.colors.siteBlack};
        border-color: ${props.theme.colors.siteBlack};
        color: ${props.theme.colors.white};
      `;
    } else if (props.green) {
      return css`
        background-color: ${props.theme.colors.buttonGreen};
        border-color: ${props.theme.colors.buttonGreen};
        color: ${props.theme.colors.white};
      `;
    } else if (props.red) {
      return css`
        background-color: ${props.theme.colors.red};
        border-color: ${props.theme.colors.red};
        color: ${props.theme.colors.white};
      `;
    }
  }}

  &:focus {
    ${props => {
      if (!props.disabled) {
        if (props.blue) {
          return css`
            box-shadow: 0 0 0 2px ${props.theme.colors.focusShadowSiteBlue};
            outline: none !important;
            color: ${props.theme.colors.white};
          `;
        } else if (props.darkBlue) {
          return css`
            box-shadow: 0 0 0 2px ${props.theme.colors.focusShadowSiteDarkNavy};
            outline: none !important;
            color: ${props.theme.colors.white};
          `;
        } else if (props.black) {
          return css`
            box-shadow: 0 0 0 2px ${rgba(lighten(5, props.theme.colors.siteBlack), 0.5)};
            outline: none !important;
            color: ${props.theme.colors.white};
          `;
        } else if (props.green) {
          return css`
            box-shadow: 0 0 0 2px ${rgba(lighten(5, props.theme.colors.buttonGreen), 0.5)};
            outline: none !important;
            color: ${props.theme.colors.white};
          `;
        } else if (props.red) {
          return css`
            box-shadow: 0 0 0 2px ${props.theme.colors.hoverRed};
            outline: none !important;
            color: ${props.theme.colors.white};
          `;
        }
        return css`
          box-shadow: 0 0 0 2px ${props.theme.colors.focusShadowSiteGrey};
          outline: none !important;
          color: ${props.theme.colors.black};
        `;
      }
    }}
  }
  &:hover {
    ${props => {
      if (!props.disabled) {
        if (props.blue) {
          return css`
            background-color: ${props.theme.colors.hoverBackgroundSiteBlue};
            border-color: ${props.theme.colors.hoverBorderSiteBlue};
            color: ${props.theme.colors.white};
          `;
        } else if (props.darkNavy) {
          return css`
            background-color: ${props.theme.colors.hoverBackgroundSiteDarkNavy};
            border-color: ${props.theme.colors.hoverBorderSiteDarkNavy};
            color: ${props.theme.colors.white};
          `;
        } else if (props.black) {
          return css`
            background-color: ${darken(0.05, props.theme.colors.siteBlack)};
            border-color: ${darken(0.1, props.theme.colors.siteBlack)};
            color: ${props.theme.colors.white};
          `;
        } else if (props.green) {
          return css`
            background-color: ${darken(0.05, props.theme.colors.buttonGreen)};
            border-color: ${darken(0.1, props.theme.colors.buttonGreen)};
            color: ${props.theme.colors.white};
          `;
        } else if (props.red) {
          return css`
            background-color: ${props.theme.colors.hoverRed};
            border-color: ${props.theme.colors.hoverRed};
            color: ${props.theme.colors.white};
          `;
        }
        return css`
          background-color: ${props.theme.colors.hoverSiteGrey};
          border-color: ${props.theme.colors.hoverBorderSiteGrey};
          color: ${props.theme.colors.black};
        `;
      }
    }}
  }
  .darkMode &:focus {
    ${props =>
      !props.disabled &&
      css`
        box-shadow: 0 0 0 2px ${props.theme.colors.dark.focusShadowSiteGrey};
      `}
  }
  &[disabled],
  &[disabled]:hover,
  &[disabled]:focus {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
    ${props => {
      if (props.blue) {
        return css`
          background-color: ${props.theme.colors.siteBlue};
          border-color: ${props.theme.colors.siteBlue};
          color: ${props.theme.colors.white};
        `;
      } else if (props.white) {
        return css`
          background-color: ${props.theme.colors.white};
          border-color: ${props.theme.colors.white};
          color: ${props.theme.colors.black};
        `;
      } else if (props.darkNavy) {
        return css`
          background-color: ${props.theme.colors.siteDarkNavy};
          border-color: ${props.theme.colors.siteDarkNavy};
          color: ${props.theme.colors.white};
        `;
      } else if (props.black) {
        return css`
          background-color: ${props.theme.colors.siteBlack};
          border-color: ${props.theme.colors.siteBlack};
          color: ${props.theme.colors.white};
        `;
      } else if (props.green) {
        return css`
          background-color: ${props.theme.colors.buttonGreen};
          border-color: ${props.theme.colors.buttonGreen};
          color: ${props.theme.colors.white};
        `;
      } else if (props.red) {
        return css`
          background-color: ${props.theme.colors.red};
          border-color: ${props.theme.colors.red};
          color: ${props.theme.colors.white};
        `;
      } else {
        return css`
          background-color: ${props.theme.colors.siteGrey};
          border-color: ${props.theme.colors.siteGrey};
          color: ${props.theme.colors.black};
        `;
      }
    }}
  }
`;

export default buttonStyle;
